import React from 'react';
import { Theme } from '../../../../theme';
import { Box, BoxProps }   from '../Box/Box';
import classNames from 'classnames';
import styles from './GridRow.css';

type GridRowProps = {
    theme?: Theme;
    style?: any;
    className?: string;
} & BoxProps;

export const GridRow = React.memo(({className, ...props}: GridRowProps) => (
    <Box className = {classNames(styles.gridRow, className)} {...props} />
));

GridRow.displayName = 'GridRow';
